<template>
    <v-card>
        <v-card-title>
            <span class="headline">{{ editar ? 'Editar zona de envio' : 'Nueva zona de envio' }}</span>
        </v-card-title>

        <v-card-text>
            <v-alert
                v-model="mostrar_alert"
                dismissible
                :type="type_alert"
            >
                <template v-html="html_alert"/>
            </v-alert>

            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12 sm6>
                        <v-text-field
                                :value="item.nombre_zona"
                                :error-messages="error_input.costo_envio"
                                min="0"
                                type="text"
                                label="Nombre de la Zona"
                                hint='Agregue un nombre descriptivo de la zona generada'
                                @input="(payload) => form.nombre_zona = payload"
                        />
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field
                            :value="item.costo_envio"
                            :error-messages="error_input.costo_envio"
                            min="0"
                            type="number"
                            label="Costo de Envio"
                            hint='Este campo permite especificar el monto que se cobrara a un usuario para el envio de sus productos mediante una zona o geocerca.'
                            @input="(payload) => form.costo_envio = payload"
                        />
                    </v-flex>
                    <v-flex xs12 sm4>
                        <v-switch
                                v-model="form.activo"
                                label="Activo"
                        />
                    </v-flex>
                    <v-flex xs12>
                        <v-btn
                                color="gray darken-1"
                                @click="form.puntos = []"
                        >
                            Borrar Puntos
                        </v-btn>
                        <v-btn
                                color="gray darken-1"
                                @click="form.puntos.pop()"
                        >
                            Borrar Ultimo Punto
                        </v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <p style="font-size: 10px;">
                            Puede crear una zona de envíos dando click en el mapa para generar los puntos y dibujar el polígono donde se especificara el costo de envió. <br> Los puntos deben ser especificados en sentido de las manecillas del reloj.
                        </p>
                    </v-flex>
                    <v-flex xs12>
                        <GmapMap
                                :center="positionMap"
                                :zoom="zoom_map"
                                style="width: 100%; height: 500px"
                                @click="setPosition"
                        >
                            <gmap-polygon :paths="form.puntos" :editable="true" @paths_changed="updateEdited($event)">
                            </gmap-polygon>
                        </GmapMap>
                    </v-flex>
                    <v-flex xs12 v-if="error_input.puntos">
                        <p style="font-size: 13px;color: red">
                            Debe de especificar al menos 3 puntos dentro del mapa
                        </p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="gray darken-1"
                @click="close"
            >
                Cancelar
            </v-btn>
            <v-btn
                color="blue darken-1"
                class="white--text"
                :loading="loading"
                :disabled="loading"
                @click="guardar"
            >
                Guardar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import EventBus from "@/EventBus";

    export default {
        name: "FormTipoPrecio",
        props: {
            item: {
                type: [Array, Object],
                default: () => {
                    return {
                        id: 0,
                        nombre_zona: '',
                        costo_envio: '',
                        activo: '',
                        puntos : []
                    }
                }
            }
        },
        data() {
            return {
                form: Object.assign({
                    id: 0,
                    nombre_zona: '',
                    costo_envio: '',
                    activo: true,
                    puntos: []
                }, this.$_clonar(this.item)),
                error_input: {
                    nombre_zona: '',
                    costo_envio: '',
                    puntos: ''
                },
                positionMap: {lat:0, lng:0},
                zoom_map:11,
                loading: false,
                mostrar_alert: false,
                type_alert: 'success',
                html_alert: ''
            }
        },
        computed: {
            editar() {
                return this.item.id > 0;
            }
        },
        watch: {
            item(val) {
                this.form = Object.assign({}, val);
                if(this.form && this.form.puntos.length){
                    this.positionMap = this.form.puntos.first();
                }
            }
        },
        mounted(){
            if(!this.form.id){
                window.navigator.geolocation.getCurrentPosition(({coords}) => {
                    this.positionMap.lat = coords.latitude;
                    this.positionMap.lng = coords.longitude;
                    this.zoom_map = 11;
                });
            }else{
                const first = this.form.puntos[0];
                this.positionMap.lat = first.lat;
                this.positionMap.lng = first.lng;
                this.zoom_map = 12;
            }
        },
        methods: {
            setPosition(position) {
                this.form.puntos.push({lat:position.latLng.lat(), lng:position.latLng.lng()});
            },
            updateEdited(mvcArray) {
                for (let i=0; i<mvcArray.getLength(); i++) {
                    const path = [];
                    for (let j=0; j<mvcArray.getAt(i).getLength(); j++) {
                        const point = mvcArray.getAt(i).getAt(j);
                        path.push({lat: point.lat(), lng: point.lng()});
                    }
                    this.form.puntos = path;
                }
            },
            close() {
                this.form.id = 0;
                this.form.nombre = '';
                this.form.puntos = [];
                this.$emit('close', true);
            },
            guardar() {
                const urlTarget = this.editar ? `/api/zona-envio/actualizar/${this.item.id}` : '/api/zona-envio/guardar';
                this.loading = true;
                this.error_input.costo_envio = '';
                this.error_input.puntos = '';
                axios.post(urlTarget, this.form)
                    .then(({data}) => {
                        this.loading = false;
                        if (data.success) {
                            this.form.nombre = '';
                            this.$emit('save', data.message);
                            this.$_showMessage(data.message)
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.error_input = Object.assign({}, error.response.data.data);
                                EventBus.$emit('tugarrafon:show-snackbar',{
                                    text_content : error.response.data.message,
                                    color : 'error'
                                })
                            }
                        } else {
                            EventBus.$emit('tugarrafon:show-snackbar',{
                                text_content : 'Error inesperado. Intenta nuevamente por favor',
                                color : 'error'
                            })
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>
